if(window.innerWidth < 800){
  $('.make-slider .quick-links').slick({
    infinite: false,
      slidesToShow: 2,
      arrows: false,
      dots: true,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 500,
              settings: {
                  slidesToShow: 1
              }
          }
      ]
  });
}

var swiper = new Swiper(".featured-swiper-slider", {
  slidesPerView: "auto",
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      centeredSlides: true,
    },
    461: {
      centeredSlides: false,
    }
  }
});

var swiper = new Swiper(".mega-menu_products", {
  slidesPerView: "auto",
  spaceBetween: 10,
  autoplay: {
    delay: 3000, // change delay as needed (in milliseconds)
    disableOnInteraction: false,
  },
  // Hide navigation arrows
  navigation: false,
});


$('.custom-design-body .product-list').flickity({
  watchCSS: true,
  pageDots: false,
  prevNextButtons: true,
  contain: true,
  resize: false,
  groupCells: true,
  cellAlign: "left",
  draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
});

// $(document).on("click",".header__cart-toggle",function() {
//   $('body').addClass('overflow_hidden');
// });
// $(document).on("click",".mini-cart__header-close",function() {
//   $('body').removeClass('overflow_hidden');
//   $('form#mini-cart').attr('aria-hidden', 'true');
// });

$(document).on("click",".mega-menu__title",function() {
  $(this).parent('.mega-menu__column').find('.mega-menu__linklist').slideToggle();
});